// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { type Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import type Enums from '../Enums';
import { NewPlant, type Plant, type PlantWireFormat } from '../Plant/Plant';
import {
  NewProjectConfigCompany,
  type ProjectConfigCompany,
  type ProjectConfigCompanyWireFormat,
} from '../ProjectConfigCompany/ProjectConfigCompany';
import {
  NewProjectConfigProduct,
  type ProjectConfigProduct,
  type ProjectConfigProductWireFormat,
} from '../ProjectConfigProduct/ProjectConfigProduct';

export class ProjectConfig {
  readonly id: string;
  readonly name: string;
  readonly plants: Plant[];
  readonly readyMixQuantityOverride: number | null;
  readonly readyMixQuantityOverrideUnit: Enums.Unit | null;
  readonly aggregateQuantityOverride: number | null;
  readonly aggregateQuantityOverrideUnit: Enums.Unit | null;
  readonly asphaltQuantityOverride: number | null;
  readonly asphaltQuantityOverrideUnit: Enums.Unit | null;
  readonly revenueOverride: Currency | null;
  readonly isArchived: boolean;
  readonly companies: ProjectConfigCompany[];
  readonly products: ProjectConfigProduct[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.plants = (data.plants ?? []).map((plants: any) => NewPlant(plants));
    this.readyMixQuantityOverride =
      data.readyMixQuantityOverride === undefined ? null : data.readyMixQuantityOverride;
    this.readyMixQuantityOverrideUnit =
      data.readyMixQuantityOverrideUnit === undefined ? null : data.readyMixQuantityOverrideUnit;
    this.aggregateQuantityOverride =
      data.aggregateQuantityOverride === undefined ? null : data.aggregateQuantityOverride;
    this.aggregateQuantityOverrideUnit =
      data.aggregateQuantityOverrideUnit === undefined ? null : data.aggregateQuantityOverrideUnit;
    this.asphaltQuantityOverride =
      data.asphaltQuantityOverride === undefined ? null : data.asphaltQuantityOverride;
    this.asphaltQuantityOverrideUnit =
      data.asphaltQuantityOverrideUnit === undefined ? null : data.asphaltQuantityOverrideUnit;
    this.revenueOverride =
      (data.revenueOverride ?? null) === null ? null : NewCurrency(data.revenueOverride);
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.companies = (data.companies ?? []).map((companies: any) =>
      NewProjectConfigCompany(companies),
    );
    this.products = (data.products ?? []).map((products: any) => NewProjectConfigProduct(products));
  }

  static zero(): ProjectConfig {
    const zeroValues: ExcludeMethodsDeep<ProjectConfig> = {
      id: NIL_UUID,
      name: '',
      plants: [],
      readyMixQuantityOverride: null,
      readyMixQuantityOverrideUnit: null,
      aggregateQuantityOverride: null,
      aggregateQuantityOverrideUnit: null,
      asphaltQuantityOverride: null,
      asphaltQuantityOverrideUnit: null,
      revenueOverride: null,
      isArchived: false,
      companies: [],
      products: [],
    };
    return new ProjectConfig(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectConfigWireFormat = {
  id: string;
  name: string;
  plants: PlantWireFormat[];
  readyMixQuantityOverride: number | null;
  readyMixQuantityOverrideUnit: string | null;
  aggregateQuantityOverride: number | null;
  aggregateQuantityOverrideUnit: string | null;
  asphaltQuantityOverride: number | null;
  asphaltQuantityOverrideUnit: string | null;
  revenueOverride: CurrencyWireFormat | null;
  isArchived: boolean;
  companies: ProjectConfigCompanyWireFormat[];
  products: ProjectConfigProductWireFormat[];
};

type NewProjectConfigProps = PartialDeep<ProjectConfig, { recurseIntoArrays: true }>;
export const NewProjectConfig: (props: NewProjectConfigProps) => ProjectConfig = (props) =>
  new ProjectConfig(props);

type NewProjectConfigFromWireFormatProps = PartialDeep<
  ProjectConfigWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectConfigFromWireFormat: (
  props: NewProjectConfigFromWireFormatProps,
) => ProjectConfig = (props) => new ProjectConfig(props);
